import React from 'react'

import clsx from 'clsx'

import classes from './Chekbox.module.scss'

/** @type {import("./types").default} */
const Checkbox = ({ className, checked, value, onChange, noAnimation, variant = 'primary', disabled }) => {
  const coreComponent = (
    <input
      type="checkbox"
      name="checkbox"
      className={clsx(classes.checkbox, classes[variant], className)}
      checked={checked}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )

  if (noAnimation) {
    return coreComponent
  }

  return (
    <span className={clsx('Checkbox', classes.ripple)}>
      <span className={clsx(classes.root, disabled && 'disabled', checked && 'checked')}>{coreComponent}</span>
    </span>
  )
}

export default Checkbox
